import styled from '@emotion/styled';
import { Stack } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledPhoto = styled(Stack)`
  display: flex;
  direction: column;
  align-items: center;
  justify-content: center;
  background: ${colors.primary25};
  color: ${colors.primary400};
  height: 320px;
  width: 270px;
  gap: 32px;
  background: ${colors.white};
  border-radius: 4px;
  stroke: #d0d5dd;
  padding: 20px;
  text-align: center;
  background-image: url('data:image/svg+xml, <svg width="270" height="320" viewBox="0 0 270 320" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="269" height="319" rx="3.5" stroke="lightgray" stroke-dasharray="10 5"/></svg>');

  & #icon-container {
    background: ${colors.gray50};
    width: 64px;
    height: 64px;
    border-radius: 4px;
    padding: 11px;
  }
`;
